import * as gtm from './GoogleTagManagerService'
import * as dataLayer from './AnalyticsDataLayer'
import { deepMerge } from '@core/Utils/object/deepMerge'
import { ClosestVenue } from '@core/Areas/VenueMode/Utils/geoFenceUtils'

/**
 * @deprecated The method should not be used for new events
 * It requires you to update the javascript in Tag Manager to pick up any new data from the dataLayer
 * Use GoogleTagManagerService/trackEvent instead to pass both the event name and any associated data
 */
export function track(name: string, data?: DeepPartial<dataLayer.AnalyticsData>): void {
  /*
   * deep merge is used to preserve the data layer.
   * Preserving the data layer is currently *required* because its properties are directly accessed and used
   * to write data to via object keys in the legacy code (see `GoogleTagManagerService`).
   */
  updateDataLayer(data)
  if (data) {
    gtm.trackEvent(name as Parameters<typeof gtm.trackKey>[0], data)
  } else {
    gtm.trackKey(name as Parameters<typeof gtm.trackKey>[0])
  }
}

export function updateDataLayer(data?: DeepPartial<dataLayer.AnalyticsData>): void {
  if (data) {
    // Make sure we were sent something that can be merged
    deepMerge(dataLayer.data, data)
  }
}

export function assignStructuredSearch(data: dataLayer.StructuredSearchData): void {
  dataLayer.data.structuredSearch = { ...dataLayer.data.structuredSearch, ...data }
}

export function assignUserInVenue(closestVenue: ClosestVenue): void {
  dataLayer.data.agency = closestVenue.inside
    ? {
        name: closestVenue.name,
        openingType: closestVenue.openingType,

        locationId: `${closestVenue.locationId}`,
        latitude: closestVenue.latitude,
        longitude: closestVenue.longitude,
        serviceType: closestVenue.serviceType,
      }
    : undefined
}

export function trackAccountNumber(accountNumber?: string): void {
  updateDataLayer({
    user: { accountNumber: accountNumber ?? '' },
  })
}

export function giddyUpViewed(): void {
  updateDataLayer({
    giddyUp: { giddyUpViewed: true },
  })
}

export function setGiddyUpQuaddieValue(value: boolean): void {
  updateDataLayer({
    giddyUp: { quaddieValueSelected: value },
  })
}

export function setGiddyUpTab(tab: string): void {
  updateDataLayer({
    giddyUp: { selectedTab: tab },
  })
}

// Types
type DeepPartial<T> = {
  [P in keyof T]?: DeepPartial<T[P]>
}
